import { useState, useEffect } from 'react';
const API = import.meta.env.VITE_API_BASE || '/api';

// Results belong to one observer/activity/effective instant. Refresh on foreground.
export function useTonight(active, observer, activity, ts) {
  const key = [observer?.lat, observer?.lon, activity, ts ?? 'live'].join('|');
  const [state, setState] = useState({ key: null, verdict: null, loading: false, error: null });
  useEffect(() => {
    if (!active || !observer) { setState({ key, verdict: null, loading: false, error: null }); return; }
    let cancelled = false, controller;
    setState({ key, verdict: null, loading: true, error: null });
    async function refresh() {
      controller?.abort(); controller = new AbortController(); const current = controller;
      const params = new URLSearchParams({ lat: observer.lat, lon: observer.lon, activity });
      if (ts != null) params.set('ts', ts);
      try {
        const response = await fetch(`${API}/verdict?${params}`, { signal: AbortSignal.any([current.signal, AbortSignal.timeout(20000)]) });
        if (!response.ok) throw new Error('Observations could not be refreshed.');
        const verdict = await response.json();
        if (!cancelled && current === controller) setState({ key, verdict, loading: false, error: null });
      } catch (error) {
        if (!cancelled && current === controller && !current.signal.aborted) setState(prev => ({ key,
          verdict: prev.key === key && prev.verdict ? { ...prev.verdict, score: null, verdict: 'Observations stale', data_status: 'stale', notification_eligible: false } : null,
          loading: false, error: error.message }));
      }
    }
    const foreground = () => { if (document.visibilityState === 'visible') refresh(); };
    refresh(); const timer = setInterval(refresh, 120000);
    document.addEventListener('visibilitychange', foreground); window.addEventListener('focus', foreground);
    return () => { cancelled = true; controller?.abort(); clearInterval(timer); document.removeEventListener('visibilitychange', foreground); window.removeEventListener('focus', foreground); };
  }, [active, key]);
  return active && state.key === key ? state : { verdict: null, loading: !!(active && observer), error: null };
}
